var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isShowConnectAdmin)?_c('ConnectAdmin'):_vm._e(),_c('router-view',{class:{ 'show-top-modal': _vm.isShowConnectAdmin }})],1)}
var staticRenderFns = []

export { render, staticRenderFns }